import _ from 'underscore';
import RequisitionModel from '../../../models/RequisitionModel';

export function setDateTime(fecha, index, requisition) {
  if (requisition.prestamo_personalizado_cantidad_pagos) {
    return (
      fecha +
      1000 *
        60 *
        60 *
        24 *
        (index * requisition.prestamo_personalizado_cantidad_pagos * 4)
    );
  } else {
    return fecha + 1000 * 60 * 60 * 24 * (index * 7 * 4);
  }
}

export function setGroupTablesByNumber(requisition, numberOfGroups = 2) {
  let newRequests = [];
  let cantidadTablas = [];
  if (requisition.prestamo_personalizado_cantidad_pagos) {
    cantidadTablas.length = Math.ceil(
      requisition.prestamo_personalizado_cantidad_pagos / 5
    );
  } else {
    cantidadTablas.length = Math.ceil(requisition.cantidad_pagos_semanales / 5);
  }
  cantidadTablas.fill(requisition.montos);
  do {
    newRequests.push(cantidadTablas.splice(0, numberOfGroups));
  } while (cantidadTablas.length > 0);
  return newRequests;
}

export function agruparBidimensional(arr, cantidad) {
  const resultado = [];
  for (let i = 0; i < arr.length; i += cantidad) {
    resultado.push(arr.slice(i, i + cantidad));
  }
  return resultado;
}

export function setNumbersPayments(requisition, numberOfGroups = 2) {
  let newNumWeekArray = [];
  let numeros = [];
  if (!_.isEmpty(requisition)) {
    if (requisition.prestamo_personalizado_cantidad_pagos) {
      for (
        let index = 0;
        index < requisition.prestamo_personalizado_cantidad_pagos;
        index++
      ) {
        numeros[index] = index + 1;
      }
      do {
        newNumWeekArray.push(numeros.splice(0, 5));
      } while (numeros.length > 0);
      numeros = [];
      do {
        numeros.push(newNumWeekArray.splice(0, numberOfGroups));
      } while (newNumWeekArray.length > 0);
    } else {
      for (
        let index = 0;
        index < requisition.cantidad_pagos_semanales;
        index++
      ) {
        numeros[index] = index + 1;
      }
      do {
        newNumWeekArray.push(numeros.splice(0, 5));
      } while (numeros.length > 0);
      numeros = [];
      do {
        numeros.push(newNumWeekArray.splice(0, numberOfGroups));
      } while (newNumWeekArray.length > 0);
    }
  }
  return numeros;
}

export function setPaymentDays(requisition, fecha, numberOfGroups) {
  if (_.isEmpty(requisition)) return [];
  return RequisitionModel.setPaymentDays(
    fecha,
    requisition.prestamo_personalizado,
    requisition.prestamo_personalizado_cantidad_pagos,
    requisition.prestamo_personalizado_periodicidad,
    requisition.cantidad_pagos_semanales,
    undefined,
    undefined,
    numberOfGroups
  );
}

export const excludeFirst = (arr) => arr.slice(1);
